import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonDoctorModel } from 'src/app/model/common/doctor';
import { CommonDoctorViewModel } from 'src/app/model/common/doctor.view';
import { CommonPersonModel } from 'src/app/model/common/person';
import { PersonService } from '../../person/person.service';
import { DOCTOR } from '../doctor.constants';
import { DoctorService } from '../doctor.service';

@Component({
  selector: 'ms-common-doctor-dialog',
  templateUrl: './doctor-dialog.component.html',
})
export class DoctorDialogComponent extends BaseComponent {
  readonly screen = DOCTOR;
  doctor: CommonDoctorModel = {};
  person: CommonPersonModel = {};

  constructor(
    protected ref: DynamicDialogRef,
    protected config: DynamicDialogConfig,
    protected service: DoctorService,
    protected personService: PersonService
  ) {
    super();
  }

  onInit = () => {
    const { doctorData } = this.service.readStore();
    const { personData } = this.personService.readStore();
    this.subscriptions.push(
      doctorData.subscribe(
        (result) => (this.doctor = this.service.setDoctorInformation(result))
      ),
      personData.subscribe((result) => {
        this.person = this.personService.setPersonInformation(result);
        if (this.person.id) {
          this.subscriptions.push(
            this.service.getDoctorByPerson(result.id!).subscribe()
          );
        }
      })
    );
  };

  save = () => {
    this.service.setLoadingState();
    const doctor = {
      ...this.doctor,
      personHelp: this.person,
    };
    delete doctor.personHelp.emailHelp;
    delete doctor.personHelp.phoneHelp;
    this.subscriptions.push(
      this.config.data.save(doctor).subscribe((result: CommonDoctorViewModel) =>
        this.ref.close({
          ...result,
          isNew: doctor.isNew,
        })
      )
    );
  };
}
